import { ThemeOptions } from '@mui/material';
import { borderRadiusBase } from '../tokens';

export const shape: ThemeOptions['shape'] = {
    borderRadius: borderRadiusBase,
} as const;
